
import React from "react";
import { Routes, Route } from "react-router-dom";

import ClinicPage from "pages/Clinic";
import ClinicEditorPage from "pages/Clinic/Editor";
import DoctorPage from "pages/Doctor";
import EventPage from "pages/Event";
import EventEditorPage from "pages/Event/Editor";
import ReviewPage from "pages/Review";
import ReviewEditPage from "common/pages/Review/ReviewEdit";
import CategoryPage from "pages/Category";
import DoctorEditorPage from "pages/Doctor/Editor";
import CounselPage from "pages/Counsel";

export default () => (
    <Routes>
        <Route path="/clinic" element={<ClinicPage />}></Route>
        <Route path="/clinic/editor" element={<ClinicEditorPage />}>
            <Route path=":clinicId" element={<ClinicEditorPage />}></Route>
        </Route>
        <Route path="/doctor" element={<DoctorPage />}></Route>
        <Route path="/doctor/editor" element={<DoctorEditorPage />}>
            <Route path=":doctorId" element={<DoctorEditorPage />}></Route>
        </Route>
        <Route path="/event" element={<EventPage />}></Route>
        <Route path="/event/editor" element={<EventEditorPage />}>
            <Route path=":eventId" element={<EventEditorPage />}></Route>
        </Route>
        <Route path="/review" element={<ReviewPage />}></Route>
        <Route path="/review/editor" element={<ReviewEditPage />}>
            <Route path=":reviewId" element={<ReviewEditPage />}></Route>
        </Route>
        <Route path="/category" element={<CategoryPage />}></Route>
        <Route path="/counsel" element={<CounselPage />}></Route>
    </Routes>
)

